import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService } from 'foundation';
import { PosHttpService } from '../../../services/pos.http.service';
import { DashboardCommentModelComponent } from '../dashboard-comment-model/dashboard-comment-model.component';

@Component({
  selector: 'app-dashboard-all-comment-model',
  templateUrl: './dashboard-all-comment-model.component.html',
  styleUrl: './dashboard-all-comment-model.component.scss'
})
export class DashboardAllCommentModelComponent {

  commentArr: Array<any> = [];
  commentObject: { textComment: string } = { textComment: '' };
  isSendTelegram: boolean = false;
  isSelected: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData,
    private dialogRef: MatDialogRef<DashboardCommentModelComponent>,
    private fnutilservice: FnUtilService,
    private toaster: FnToasterService,
    private posHttpSvcs: PosHttpService
  ) { }

  ngOnInit(): void {
  }

  addComment(): void {
    if (this.fnutilservice.isEmptyObject(this.commentObject.textComment)) {
      this.toaster.error('Please add comment here...');
      return
    }
    const pktData = {
      commentText: this.commentObject.textComment,
      isSendTelegram: this.isSendTelegram,
      pk: this.dialogData.comments.
        map((data: any) => data.primaryKey)
    };
    this.posHttpSvcs.authPost('v1/ui/saveComment', 'saveComment', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error(resp.data.commentText);
        return;
      } else {
        this.toaster.success("Comment added");
        this.dialogData.comments.forEach((comment: any) => {
          comment.recentComment = resp.data.commentText;
          comment.lastActionAt = resp.data.commentedAt;
        });
        if (this.isSendTelegram) {
          this.sendtoTelegram();
        }
        this.commentObject.textComment = '';
      }
    }));
    this.close();
  }

  sendtoTelegram(): void {
    const pktData = {
      msg: this.commentObject.textComment,
      pk: this.dialogData.comments.map((data: any) => data.primaryKey),
      action : 'Comment Added'
    };
    this.posHttpSvcs.authPost('v1/ui/generateTelegram', 'generateTelegram', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("Telegram Msg not sent");
        return;
      }
    }));
  }

  close() {
    this.dialogRef.close();
  }

  selectionCheck(event: any): void {
    this.isSelected = event.target.checked;
  }
}

interface HwDialogData {
  comments: any;
}

